(ns web3.components.legal
  (:require [web3.env :as env]
            [web3.i18n :as i]
            [web3.modals.alerts :as alerts]
            [web3.persistence.local :as local]
            [re-frame-simple.db :as db]
            [kitchen-async.promise :as p]))

(def accepted-key ::accepted-TOC)

(local/init-storage [accepted-key] false)

(when (:devtools? env/config)
  (db/assoc! accepted-key false))

(defn accepted? []
  (db/get accepted-key))

(defn TOC [{:keys [on-response]}]
  (when-not (accepted?)
    (alerts/add-frame [alerts/alert-view
                       {:text-primary
                        (i/to-do (str "Please accept " (:partner/name env/config)
                                      "'s Terms of Use to view this item."))

                        :text-secondary
                        [:a
                         {:href "https://www.homeserve.com/en-us/app/terms"
                          :target "_blank"
                          :rel "noopener"}
                         (i/to-do "Review Terms of Use")]

                        :buttons
                        (-> [{:on-click (fn []
                                          (db/assoc! accepted-key true)
                                          (alerts/drop-frames 1)
                                          (when on-response (on-response true)))
                              :label (i/to-do "I Accept")
                              :class "pad-v-3"
                              :style {:border-top "1px solid white"}}
                             {:on-click (fn []
                                          (when on-response (on-response false))
                                          (.assign js/location "https://www.homeserve.com/app"))
                              :label (i/to-do "Close")
                              :class "pad-v-3"
                              :style {:border-top "1px solid white"}}])}])))

(defn request-response []
  (if (accepted?)
    (p/resolve true)
    (p/promise [resolve reject]
      (TOC {:on-response resolve}))))